import { useQuery } from '@tanstack/react-query';
import { contactApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

const REFERENCE_STALE_TIME = 5 * 60_000;

export function useContacts() {
  return useQuery({
    queryKey: queryKeys.organization.contacts(),
    queryFn: ({ signal }) => contactApiClient.list({}, toCancelToken(signal)),
    staleTime: REFERENCE_STALE_TIME,
    meta: {
      suppressErrorToast: true,
      errorContext: 'organization contacts',
    },
  });
}
